import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c31d7d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Inventory" }
const _hoisted_2 = { class: "mt-4 bg-white rounded" }
const _hoisted_3 = { class: "p-4 flex items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_6 = { class: "p-4 pt-0" }
const _hoisted_7 = { class: "max-w-full overflow-hidden overflow-x-auto" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка остатков...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении списка остатков произошла ошибка ", -1))
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wait_list_status_modal = _resolveComponent("wait-list-status-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_InventoryTMSFilters = _resolveComponent("InventoryTMSFilters")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_inventory_tms_row = _resolveComponent("inventory-tms-row")!
  const _component_inventory_tms_row_overall = _resolveComponent("inventory-tms-row-overall")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.wait_list_state.is_opened)
      ? (_openBlock(), _createBlock(_component_wait_list_status_modal, {
          key: 0,
          order: _ctx.wait_list_state.order,
          loading: _ctx.wait_list_state.is_loading,
          type: 2,
          "is-inventory": "",
          onCancel: _ctx.cancelWaitList,
          onSubmit: _ctx.setWaitListStatus
        }, null, 8, ["order", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Остатки" }),
    _createVNode(_component_InventoryTMSFilters, {
      class: "mt-5",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_button, {
          class: "NewButton--search mr-3",
          loading: _ctx.state.is_loading,
          disabled: !_ctx.state.list.length,
          onClick: _ctx.tablesStore.toggleModal
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createVNode(_component_new_button, {
          loading: _ctx.state.is_excel_loading,
          disabled: _ctx.state.is_excel_loading,
          class: "NewButton--search",
          onClick: _ctx.downloadReportInventory
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_table_scroll_wrapper, {
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.state.is_loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_loader, { class: "primary" }),
                          _hoisted_9
                        ], 64))
                      : (_ctx.state.is_failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_10,
                            _createVNode(_component_new_button, {
                              class: "mt-1",
                              onClick: _ctx.loadInventory
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Перезагрузить ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.state.list.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Список остатков пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock(_component_new_table, {
                    key: 1,
                    columns: _ctx.TABLE_COLUMNS,
                    "nested-rows": _ctx.state.list,
                    "expanded-rows": _ctx.state.expanded_rows,
                    "clickable-rows": "",
                    "nested-rows-expand-key": "invoices",
                    "expanded-rows-key": "navigationName",
                    onParentRowClick: _ctx.toggleRow,
                    onFilter: _ctx.sortByDate,
                    fixed: ""
                  }, {
                    td: _withCtx(({ column, row }) => [
                      _createVNode(_component_inventory_tms_row, {
                        column: column,
                        row: row,
                        index: _ctx.state.list.indexOf(row),
                        onWaitList: _ctx.startWaitList
                      }, null, 8, ["column", "row", "index", "onWaitList"])
                    ]),
                    overallNested: _withCtx(({ column, row }) => [
                      _createVNode(_component_inventory_tms_row_overall, {
                        totals: row.totals,
                        column: column
                      }, null, 8, ["totals", "column"])
                    ]),
                    overall: _withCtx(({ column }) => [
                      _createVNode(_component_inventory_tms_row_overall, {
                        totals: _ctx.state.totals,
                        column: column
                      }, null, 8, ["totals", "column"])
                    ]),
                    _: 1
                  }, 8, ["columns", "nested-rows", "expanded-rows", "onParentRowClick", "onFilter"]))
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}